import { FixedParamsTable } from '../../Tables/FixedParamsTable/FixedParamsTable';
import { MICRONUTRIENT_CODES } from '../../../constants/parameters.constants';
import type { FixedParam } from '../../../types/parameters.types';

interface MicronutrientsTabProps {
	fixedParams: FixedParam[];
	isLoading: boolean;
	onChange: (params: FixedParam[]) => void;
}

export const MicronutrientsTab = ({ fixedParams, isLoading, onChange }: MicronutrientsTabProps) => {
	const subset = fixedParams.filter((p) => MICRONUTRIENT_CODES.includes(p.code));

	const handleChange = (updatedSubset: FixedParam[]) => {
		const merged = fixedParams.map((p) => updatedSubset.find((u) => u.code === p.code) ?? p);
		onChange(merged);
	};

	return <FixedParamsTable params={subset} isLoading={isLoading} onChange={handleChange} />;
};
